import { CondicaoDocumentoDto } from "src/app/pagamento/models/condicao-documento-dto";

export const CONDICAO_DOCUMENTO_DTO: CondicaoDocumentoDto[] = [
  { codigo: 1, descricao: "Pago", isSistematicaAntiga: null },
  { codigo: 2, descricao: "Emitido", isSistematicaAntiga: null },
  { codigo: 3, descricao: "Agendado", isSistematicaAntiga: null }
];